exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._334OgRpZliYyKnUQS2z9PK {\n\tfloat: right;\n\tmargin: 2px;\n}\n._334OgRpZliYyKnUQS2z9PK > * {\n\tdisplay: block;\n\tfloat: left;\n\twidth: auto;\n\tmargin: 5px;\n\tpadding: 3px;\n\tborder-radius: 3px;\n\tpadding-left: 5px;\n\tpadding-right: 5px;\n}\n._3-21KFdJJKjM58tAvkLPyt{\n}\n._2LRljpzLqBQkgrQ5qK0oQb{\n}", ""]);

// exports
exports.locals = {
	"languagechoice": "_334OgRpZliYyKnUQS2z9PK",
	"active": "_3-21KFdJJKjM58tAvkLPyt",
	"inactive": "_2LRljpzLqBQkgrQ5qK0oQb"
};